<app-hero id="hero"></app-hero>
<app-services id="services"></app-services>
<!-- <app-teams id="teams"></app-teams> -->
<app-projects id="projects"></app-projects>
<app-contacts id="contact-us"></app-contacts>
